import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { ProductDetailsDeliverySettings } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: ProductDetailsDeliverySettings.NAME,
        oldNameMatcher: /^pdp_delivery_settings_rendering/m,
      },
    ],
  });
};
